import { RouteSection } from "../components/organisms/NavSection/types";
import { DocumentIcon } from "./icons";

const navListRoutes: RouteSection[] = [
  {
    title: "Administración de Contenidos",
    children: [
      {
        text: "Storage",
        path: "/app/content-management/manage-storage",
        icon: DocumentIcon,
        children: [
          {
            text: "Biblioteca multimedia",
            path: "/app/content-management/manage-storage",
          },
        ],
      },
      {
        text: "Home",
        path: "/app/content-management/manage-banners",
        icon: DocumentIcon,
        children: [
          {
            text: "Banner principal",
            path: "/app/content-management/manage-banners",
          },
          {
            text: "Secciones intermedias",
            path: "/app/content-management/manage-info-cards",
          },
          {
            text: "Quiero aplicar",
            path: "/app/content-management/manage-info-apply",
          },
          {
            text: "Bloque de texto",
            path: "/app/content-management/manage-info-talent",
          },
          {
            text: "Lista de ítems",
            path: "/app/content-management/manage-list-items",
          },
        ],
      },
      {
        text: "Quiénes somos",
        path: "/app/content-management/manage-about-us",
        icon: DocumentIcon,
        children: [
          {
            text: "¿Quiénes somos?",
            path: "/app/content-management/manage-about-us",
          },
          {
            text: "Equipo",
            path: "/app/content-management/manage-staff",
          },
          {
            text: "Integrantes del equipo",
            path: "/app/content-management/manage-staff-team",
          },
        ],
      },
      {
        text: "Qué hacemos",
        path: "/app/content-management/manage-our-work",
        icon: DocumentIcon,
        children: [
          {
            text: "Qué hacemos",
            path: "/app/content-management/manage-our-work",
          },
        ],
      },
      {
        text: "Portafolio",
        path: "/app/content-management/manage-portofolio",
        icon: DocumentIcon,
        children: [
          {
            text: "Portafolio",
            path: "/app/content-management/manage-portofolio",
          },
          {
            text: "Empresas",
            path: "/app/content-management/manage-enterprises",
          },
          {
            text: "Fundadores",
            path: "/app/content-management/manage-founders",
          },
        ],
      },
      {
        text: "Cómo aplicar",
        path: "/app/content-management/manage-how-to-apply",
        icon: DocumentIcon,
        children: [
          {
            text: "Cómo aplicar",
            path: "/app/content-management/manage-how-to-apply",
          },
          {
            text: "Tarjetas de aplicación",
            path: "/app/content-management/manage-card-apply",
          },
          {
            text: "Preguntas frecuentes",
            path: "/app/content-management/manage-faqs",
          },
        ],
      },
    ],
  },
];

export default navListRoutes;